/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useState} from "react";
import {
    AccountBoxOutlined,
    BadgeOutlined,
    DashboardOutlined,
    LocalShippingOutlined,
    SummarizeOutlined
} from "@mui/icons-material";
import Seccion_Despachos from "./Secciones/Seccion_Despachos";
import Seccion_Directorio from "./Secciones/Seccion_Directorio";
import Seccion_Potenciales from "./Secciones/Seccion_Potenciales";
import {funSalir} from "../Servicios/Auth/funSalir";
import Seccion_Dashboard from "./Secciones/Seccion_Dashboard";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";

export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)


    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: funSalir

    }


    const {Provider} = contexBarra;

    return (
        <Grid2
            container
            size={12}
        >
            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil}/>
            </Provider>

        </Grid2>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Dashboard',
        icono: DashboardOutlined,
        camino: '/Dashboard',
        categoria: 'Metricas',
        Componente: <Seccion_Dashboard/>
    },
    {
        nombre: 'Despachos',
        icono: LocalShippingOutlined,
        camino: '/Pedidos',
        categoria: 'Pagina',
        Componente: <Seccion_Despachos/>
    },
    {
        nombre: 'Directorio',
        icono: SummarizeOutlined,
        camino: '/Directorio',
        categoria: 'Pagina',
        Componente: <Seccion_Directorio/>
    },
    {
        nombre: 'Potenciales',
        icono: AccountBoxOutlined,
        camino: '/Potenciales',
        categoria: 'Pagina',
        Componente: <Seccion_Potenciales/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Accesos',
        Componente: <Seccion_Usuarios/>
    }

]

const seccionesPerfil = []

const notificaciones = {}